import styles from 'src/assets/styles/top/styles.module.styl'
import ShuffleLetter from 'src/components/atoms/ShuffleLetter'

class ShuffleTypo {
  constructor(elem,text, delay = 0, speed = 1, defState = 'PRE_ROLL_IN', rollNum = 8, letterDelay = 4) {
    this.elem = elem
    
    this.letterDelay = letterDelay;
    this.state = defState;
    this.oldState = ' '
    this.letters = text;
    this.letterItems = new Array();
    if(this.state == 'PRE_ROLL_OUT'){
      this.text = this.letters
    }else{
      this.text = ' '
    }
    this.delay = delay
    this.speed = speed
    
    this.rollNum = rollNum
    this.init();
  }
  reset() {
    if(this.state == 'PRE_ROLL_OUT'){
      this.text = this.letters
    }else{
      this.text = ' '
    }
    for (let i = 0; i < this.letterItems.length; i++) {
      const letter = this.letterItems[i];
      letter.reset()
    }
  }
  init() {
    this.createLetter();
  }
  createLetter() {
    if (this.state == 'PRE_ROLL_IN') {
      this.text = ' ';
    }
    
    for (let i = 0; i < this.letters.length; i++) {
      const text = this.letters[i];
      const prevLetterDelay = (i > 0) ? this.letterItems[i - 1].delay : 0;
      
      // const delay = (Math.random()>0.5)?1+Math.floor(Math.random()*20):0;
      let nextDelay = Math.floor(Math.random() * this.letterDelay)/this.speed
      if(Math.random()>0.96){
        nextDelay = 3*nextDelay
      }

      let delay0Ratio = 0.99
      if(this.rollNum == 0 && this.letterDelay == 2){
        delay0Ratio = 0.5
      }

      if(Math.random()>delay0Ratio){
        nextDelay = 0
      }

      const delay = prevLetterDelay + nextDelay;
      this.letterItems.push(new ShuffleLetter(i, text, delay,this.speed,this.rollNum));
      if (this.state == 'HIDE' || this.state == 'PRE_ROLL_OUT') {
        this.letterItems[i].text = text;
      }
      if (i == this.letters.length - 1) {
        
        this.duration = delay + this.letterItems[i].rollNum * (1 / this.letterItems[i].rollSpeed);
      }
    }
  }
  changeState() {
    switch (this.state) {
      case 'HIDE':
        this.elem.classList.add('hide')
        break;
      case 'SHOW':
        this.elem.classList.remove('roll_in')
        this.elem.classList.add('show')
        break;
      case 'PRE_ROLL_IN':
        this.elem.classList.remove('hide')
        break;
      case 'PRE_ROLL_OUT':
        this.elem.classList.remove('show')
        break;
      case 'ROLL_IN':
        
        this.elem.classList.add('roll_in')
        for (let i = 0; i < this.letterItems.length; i++) {
          const item = this.letterItems[i];
          item.state = 'PRE_ROLL_IN';
        }
        break;
      case 'ROLL_OUT':
        for (let i = 0; i < this.letterItems.length; i++) {
          const item = this.letterItems[i];
          item.state = 'PRE_ROLL_OUT';
        }
        break;
      default:
        break;
    }
  }
  render(time) {
    this.oldState = this.state;
    
    switch (this.state) {
      case 'HIDE':
        break;
      case 'SHOW':
        break;
      case 'PRE_ROLL_IN':
        this.delay--;
        if (this.delay < 1) {
          this.state = 'ROLL_IN';
        }
        break;
      case 'PRE_ROLL_OUT':
        this.delay--;
        if (this.delay < 1) {
          this.state = 'ROLL_OUT';
        }
        break;
      case 'ROLL_IN':
        for (let i = 0; i < this.letterItems.length; i++) {
          const item = this.letterItems[i];
          item.render(time);
          if (item.state == 'ROLL_IN' || item.state == 'SHOW') {
            const currentText = this.text
            this.text = currentText.slice(0, item.id) + item.text + currentText.slice(item.id + 1);
          }
          
          if (item.state == 'SHOW' && i == this.letterItems.length - 1) {
            this.state = 'SHOW';
            this.text = this.letters
            let replaced = this.text.replace(/_n/g, '\n')
            replaced = replaced.replace(/_s/g, '\u0020')
            this.elem.textContent = replaced
          }
          
        }
        break;
      case 'ROLL_OUT':
        for (let i = 0; i < this.letterItems.length; i++) {
          const item = this.letterItems[i];
          item.render(time);
          if (item.state == 'ROLL_OUT' || item.state == 'HIDE') {
            const currentText = this.text
            this.text = currentText.slice(0, item.id) + item.text + currentText.slice(item.id + 1);
          }
          
          if (item.state == 'HIDE' && i == this.letterItems.length - 1) {
            this.state = 'HIDE';
          }
          
        }
        break;
      default:
        break;
    }
    if (this.state != this.oldState) {
      this.changeState();
    }
  }
}

export default ShuffleTypo